export function BrowseGenres() {
  return <div></div>;
}
